import "./styles.less";

import { Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { ReportPropertyProps } from "./hook";

import { FlagOutlined } from "@ant-design/icons";
import { Button } from "shared-components/Components/Buttons/web";
import { Modal } from "shared-components/Components/Modal/web";
import { FormReport } from "./FormReport";

interface FlagIconProps {
	size?: any;
  }
  
const FlagIcon: React.FC<FlagIconProps> = ({ size = 28 }) => {
return (
	<svg 
	viewBox="64 64 896 896" 
	focusable="false" 
	data-icon="flag" 
	width={size} 
	height={size} 
	aria-hidden="true"
	>
	<path 
		d="M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" 
		fill="#fff"
	/>
	
	<path 
		d="M184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" 
		fill="#000"
		fillOpacity={0.5}
	/>
	</svg>
);
};

export const ReportButton = ({
	id,
	mode = "property",
	isEspecial,
	isDisabledProperty = false,
	type = "default",
}: ReportPropertyProps) => {
	const [modal, setModal] = useState(false);
	const [tooltip, setTooltip] = useState(false);

	return (
		<>
			<Tooltip
				title={mode == "project" ? "Denunciar Proyecto" : "Denunciar Propiedad"}
				trigger={"hover"}
				visible={!isDisabledProperty && tooltip && !modal}
				onVisibleChange={e => setTooltip(e)}>
				<Button
					disabled={isDisabledProperty}
					className={`report-button button button-secondary secondary ${
						isEspecial ? "isEspecial" : ""
					}`}
					type={type == "justIcon" ? "noStyle" : "secondary"}
					style={{marginBottom:type == "justIcon" ? 7 : 0}}
					onClick={() => {
						setModal(true);
						setTooltip(false);
					}}>
					{type == "justIcon" ? (
						<FlagIcon size={28} />
					) : (
						<FlagOutlined className="report-icon" />
					)}
					{!isEspecial && type!=="justIcon" ? "Reportar" : null}
				</Button>
			</Tooltip>
			<Modal
				classes={"report-property-modal"}
				show={modal}
				title={
					<Typography.Title
						children={mode == "project" ? "Reportar Proyecto" : "Reportar Propiedad"}
						level={4}
						style={{ margin: 0 }}
					/>
				}
				onClose={() => setModal(false)}
				children={
					<FormReport id={id} setModal={setModal} />
				}
			/>
		</>
	);
};

